import { Injectable } from '@angular/core';
import { AuthService } from '../shared/auth.service';
import { Response, Request, RequestOptions, ResponseContentType, Http } from '@angular/http';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { LoadingService } from '../loading.service';
import { catchError } from 'rxjs/operators';
import {Observable} from 'rxjs/Rx';


@Injectable({
  providedIn: 'root'
})
export class AllservicesService 
{
  checkingstate:boolean=false;
  constructor(
    private _http: HttpClient,
    private _http1:Http,
    private _authService: AuthService,
    private _loadingService: LoadingService
) {}
//  downloadFileGET(DocID): Observable<Blob> {
//     let options = new RequestOptions({responseType: ResponseContentType.Blob });
//     return this._http.get(`${CONFIG.documentsfileApiUrlBase}/${DocID}`, options)
//         .map(res => res.blob())
//         .catch(this.handleError)
// }
  //downloadFile(DocID,docRef2): Observable<Blob> {
   // let httpOptions =  new RequestOptions({responseType: ResponseContentType.Blob });
    // const httpOptions = {            
    //     headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${this._authService.token}`,
    //     responseType: 'blob'
    //     })
    // };
//     var body = { filename: docRef2 };
//     return this._http.post(`${CONFIG.documentsApiUrlBase}/${DocID}`, body, {
//   responseType: "blob",
//   headers: new HttpHeaders().append("Content-Type", "application/json")
// }).map(res => res as Blob);
    // return this._http.put(`${CONFIG.documentsApiUrlBase}/${DocID}`,httpOptions, {responseType: 'blob' as 'json'})
    // .pipe(
    //    catchError(this.handleError)
    // )
    //    .map(res => res as Blob)
    //    .catch(this.handleError)
//}
getfileData(url) {        
    this._loadingService.show();
    const httpOptions = { 
        headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this._authService.token}`
        })
    };

    return this._http.get(url, httpOptions)        
        .map(response => {
            if (response) {
                return response;
            } else {
                throw new Error('Error Getting Data');
            }
        })
        .catch(this.handleError)
        .finally(() => {
            this._loadingService.hide();
        });
}

getData(url) {        
    this._loadingService.show();
    const httpOptions = { 
        headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this._authService.token}`
        })
    };
  // console.log(url);
    return this._http.get(url,httpOptions)   
    .map(response => {
            if (response) {
                return response;
            } else {
                throw new Error('Error Getting Data');
            }
        })
       
        .catch(this.handleError)
        .finally(() => {
            this._loadingService.hide();
        });
}

deleteData(url) {
    this._loadingService.show();
    const httpOptions = { 
        headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this._authService.token}`
        })
    };
   // const httpOptions = new RequestOptions({ headers: headers });
    return this._http.delete(url, httpOptions)
        .map(response => {
            return response;
        })
        .catch(this.handleError)
        .finally(() => {
            this._loadingService.hide();
        });
}

postData(newData, url) {
    this._loadingService.show(); 
    const httpOptions = { 
        headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this._authService.token}`
        })
    };
    const body = JSON.stringify(newData);
    //console.log(body);
    //console.log(url);
    return this._http.post(url, body, httpOptions)       
        .map(response => {
            return response;
        })
        .catch(this.handleError)
        .finally(() => {
            this._loadingService.hide();
        });
}

putData(updatedData, url) {
    this._loadingService.show();
    const httpOptions = { 
        headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this._authService.token}`
        })
    };
    const body = JSON.stringify(updatedData);
    return this._http.put(url, body, httpOptions)
        .map(response => {
            return response;
        })
        .catch(this.handleError)
        .finally(() => {
            this._loadingService.hide();
        });
        
}

/*
Utility error handler function for server errors
*/
private handleError(error) {
    if(error.status && error.status === 401) {
        return Observable.throw('Session Expired- please log in');
    }

    return Observable.throw('Server Error');
}
}
